import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isLoading: false,
  loadingRequests: 0
};

const loadingSlice = createSlice({
  name: 'loading',
  initialState,
  reducers: {
    startLoading: (state) => {
      state.loadingRequests++;
      state.isLoading = true;
    },
    stopLoading: (state) => {
      state.loadingRequests = Math.max(0, state.loadingRequests - 1);
      state.isLoading = state.loadingRequests > 0;
    }
  }
});

export const { startLoading, stopLoading } = loadingSlice.actions;
export default loadingSlice.reducer; 